import { jwtDecode } from 'jwt-decode';
export function isTokenExpired(token: string) {
  if (!token) return true;
  try {
    const decoded : any = jwtDecode(token);
    const now = Date.now() / 1000;
    return decoded  .exp < now;
  } catch (error) {
    console.log(error)
    return true;
  }
}